/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Resource_Allocations_Status_FreeInputs */

const en_admin_resources_resource_allocations_status_free = /** @type {(inputs: Admin_Resources_Resource_Allocations_Status_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free`)
};

const de_admin_resources_resource_allocations_status_free = /** @type {(inputs: Admin_Resources_Resource_Allocations_Status_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frei`)
};

const es_admin_resources_resource_allocations_status_free = /** @type {(inputs: Admin_Resources_Resource_Allocations_Status_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponible`)
};

const fr_admin_resources_resource_allocations_status_free = /** @type {(inputs: Admin_Resources_Resource_Allocations_Status_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Libre`)
};

/** @type {(inputs: Admin_Resources_Resource_Allocations_Status_FreeInputs) => LocalizedString} */
const it_admin_resources_resource_allocations_status_free = en_admin_resources_resource_allocations_status_free;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Status_FreeInputs) => LocalizedString} */
const pt_br2_admin_resources_resource_allocations_status_free = en_admin_resources_resource_allocations_status_free;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Status_FreeInputs) => LocalizedString} */
const pl_admin_resources_resource_allocations_status_free = en_admin_resources_resource_allocations_status_free;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Status_FreeInputs) => LocalizedString} */
const hu_admin_resources_resource_allocations_status_free = en_admin_resources_resource_allocations_status_free;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Status_FreeInputs) => LocalizedString} */
const ro_admin_resources_resource_allocations_status_free = en_admin_resources_resource_allocations_status_free;

/**
* | output |
* | --- |
* | "Free" |
*
* @param {Admin_Resources_Resource_Allocations_Status_FreeInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_resource_allocations_status_free = /** @type {((inputs?: Admin_Resources_Resource_Allocations_Status_FreeInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Resource_Allocations_Status_FreeInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_resource_allocations_status_free(inputs)
	if (locale === "de") return de_admin_resources_resource_allocations_status_free(inputs)
	if (locale === "es") return es_admin_resources_resource_allocations_status_free(inputs)
	if (locale === "fr") return fr_admin_resources_resource_allocations_status_free(inputs)
	if (locale === "it") return it_admin_resources_resource_allocations_status_free(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_resource_allocations_status_free(inputs)
	if (locale === "pl") return pl_admin_resources_resource_allocations_status_free(inputs)
	if (locale === "hu") return hu_admin_resources_resource_allocations_status_free(inputs)
	return ro_admin_resources_resource_allocations_status_free(inputs)
});
export { admin_resources_resource_allocations_status_free as "admin.resources.resource_allocations.status_free" }